export default {"src":"/blogs/_next/static/media/facebook-app-symbol.8b39af6e.svg","height":20,"width":11,"blurWidth":0,"blurHeight":0};